/**
 * Animacja listy elementów w ofercie
 *
 * Obserwuje sekcje (domyślnie: #section3 .subsection)
 * Kiedy sekcja pojawia się w widoku, odpala animację
 * elementów <li> wewnątrz listy o klasie .animated-list
 * Każdy element wchodzi sekwencyjnie, jeden po drugim
 *
 * Użyty IntersectionObserver do wykrycia, że sekcja
 * weszła w widok (threshold 0.1 = 10% sekcji widocznej)
 *  - threshold: 0.1 → określa, jak wcześnie zaczyna animować
 *  - duration (ms): czas trwania animacji pojedynczego elementu
 *  - możesz też zmienić selektor sekcji (np. zamiast #section3)
 **/

export function initListAnimations() {
  // 🔹 Funkcja animująca pojedynczy element
  function animateItem(item, duration = 300) {
    return new Promise(resolve => {
      function onAnimationEnd() {
        item.removeEventListener('animationend', onAnimationEnd);
        resolve();
      }
      item.addEventListener('animationend', onAnimationEnd);

      // Reset animacji
      item.style.animation = 'none';
      item.style.opacity = 0;
      item.style.transform = 'translateY(-50px)';

      // Krótkie opóźnienie, żeby reset zadziałał
      setTimeout(() => {
        item.style.animation = `fadeDropIn ${duration}ms forwards cubic-bezier(0.4, 0, 0.2, 1)`;
      }, 20);
    });
  }

  // Funkcja animująca listę sekwencyjnie
  async function animateListSequentially(listElement) {
    const items = listElement.querySelectorAll('li');
    if (!items.length) return;

    // Reset wszystkiego na start
    items.forEach(item => {
      item.style.animation = 'none';
      item.style.opacity = 0;
      item.style.transform = 'translateY(-50px)';
    });

    // Animuj kolejno, czekając na zakończenie poprzedniego
    for (const item of items) {
      await animateItem(item);
    }
  }

  // Obserwator sekcji (np. #section3)
  const sections = document.querySelectorAll('#section3 .subsection');
  if (!sections.length) {
    console.warn('⚠️ Nie znaleziono sekcji do animowania (#section3 .subsection)');
    return;
  }

  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.1,
  };

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const ul = entry.target.querySelector('.animated-list');
        if (ul) animateListSequentially(ul);
      }
    });
  }, observerOptions);

  sections.forEach(section => observer.observe(section));

}
